import { useTranslation } from 'react-i18next';
import BllinkUtils from '../../../common/utils/utils';
import CacheData from '../../../common/utils/cacheData';
import ActionsCard from './actionsCards/ActionsCard';
import { ActionsWrapper } from './BankAdjustmentsNew.styled';

const ApprovedActions = ({ transactions, filter }) => {
    const { t } = useTranslation();

    CacheData.cache('bankAdjustmentsTab', 'approved');

    return (
        <ActionsWrapper>
            {transactions.length === 0 && <div className='no_records'>{t('expenses.bank_adjustments.no_records')}</div>}
            {transactions.map((transaction, i) => {
                const date = transaction.chargeDate || transaction.PaymentDate;
                const amount = transaction.amount || transaction.Amount;
                const currency = transaction.currency || transaction.payment?.Currency;
                const hasReceipt = transaction.hasReceipt;
                const paymentObject = transaction.expenseTypeKey || transaction.paymentDetails?.PaymentPlan?.ExtraInfo?.ApartmentNumber;
                const paymentMethod = transaction.methodText || transaction.Method || transaction.method;
                const paymentID = transaction.paymentID || transaction.expenseID;
                const paymentType = transaction.type ? transaction.type : transaction.isIncome ? t('expenses.income') : t('expenses.expense');
                const method = transaction.Method || transaction.method;
                const showItem  = BllinkUtils.Filter.filterItems([transaction.methodText, transaction.type, amount, date, paymentObject, paymentID, paymentMethod], filter);
                    
                return (     
                    showItem && (
                        <ActionsCard 
                            key={i} 
                            date={date} 
                            amount={amount}
                            currency={currency}
                            paymentType={paymentType} 
                            paymentObject={paymentObject} 
                            paymentMethod={paymentMethod} 
                            documentNumber={paymentID}
                            paymentID={paymentID}
                            hasReceipt={hasReceipt}
                            method={method}
                        />
                    ) 
                )
            })}            
        </ActionsWrapper>
    );
};

export default ApprovedActions;